export default function Field({ label, hint, children, style, className = '' }) {
  return (
    <div className={`field ${className}`.trim()} style={style}>
      {label && <label>{label}</label>}
      {children}
      {hint && <div className="hint">{hint}</div>}
    </div>
  );
}
